export default __webpack_public_path__ + "static/facebook-ads-secret-recipies-0460cddbbea0a3eae3fe29570a7fe084.png";